// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fenge[data-v-2666372a]{background-color:#9fd8f3;height:30px;margin-top:20px;clear:both}.footer[data-v-2666372a]{background-color:#337da2;padding:20px 0;clear:both}.footer .footerBox[data-v-2666372a]{width:1000px;margin:0 auto;color:#d2d2d2;font-size:16px;line-height:30px}.footer .footerBox span[data-v-2666372a]{margin-right:30px}", ""]);
// Exports
module.exports = exports;
